// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { MessagePixPayment } from './message-pix-payment';
import { PixPispBankList } from './pix-pisp-bank-list';

export function PixPispPaymentInformation() : Node {
  return(
    <Root>
      <MessagePixPayment />
      <PixPispBankList />
    </Root>
  );
}

const Root = styled.div`
  margin-top: 20px;
`;
